import { ButtonSkeleton } from "@/components/ui/button";
import { TextSkeleton } from "@/features/projects/components/text-skeleton";

/*
 * ContextSkeleton component
 */
export const ContextSkeleton = () => {
  /* Render */
  return (
    <div className="flex flex-col gap-4 px-7 py-4 min-h-screen max-h-screen">
      <div className="flex justify-between items-center">
        <div className="flex justify-center items-center gap-1">
          <ButtonSkeleton className="size-10" />
          <TextSkeleton variant="h3" className="ml-4 w-44 h-10" />
        </div>
      </div>

      <TextSkeleton variant="h1" className="w-44" />

      <div className="grow flex flex-row gap-4 max-h-full overflow-hidden">
        {/* Context list */}
        <div className="flex flex-col gap-4 overflow-y-auto">
          <div className="flex items-center justify-center size-14 rounded-lg skeleton"></div>
          <div className="flex items-center justify-center size-14 rounded-lg skeleton"></div>
          <div className="flex items-center justify-center size-14 rounded-lg skeleton"></div>
          <div className="flex items-center justify-center size-14 rounded-lg skeleton"></div>
          <div className="flex items-center justify-center size-14 rounded-lg skeleton"></div>
          <div className="flex items-center justify-center size-14 rounded-lg skeleton"></div>
        </div>

        {/* Context render with dropzone */}
        <div className="grow flex flex-row bg-base-300 rounded-lg overflow-hidden max-h-full relative p-6 skeleton"></div>

        {/* Context pack details */}
        <div className="flex flex-col min-w-[370px] max-w-[20vw] p-4 min-h-full rounded-lg">
          <TextSkeleton variant="h2" />
          <div className="flex mt-4 justify-between p-3 border-b border-base-300">
            <TextSkeleton variant="p" className="w-24" />
            <TextSkeleton variant="p" className="w-36" />
          </div>
          <div className="flex justify-between p-3 border-b border-base-300">
            <TextSkeleton variant="p" className="w-36" />
            <TextSkeleton variant="p" className="w-24" />
          </div>
          <div className="flex justify-between p-3 border-b border-base-300">
            <TextSkeleton variant="p" className="w-36" />
            <TextSkeleton variant="p" className="w-24" />
          </div>
          <div className="flex justify-between p-3 border-b border-base-300">
            <TextSkeleton variant="p" className="w-24" />
            <TextSkeleton variant="p" className="w-36" />
          </div>
        </div>
      </div>
    </div>
  );
};
